import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'
import Hero from '../components/maketApp/site/Hero'
import TrustBar from '../components/maketApp/site/TrustBar'
import Services from '../components/maketApp/site/Services'
import WhyUs from '../components/maketApp/site/WhyUs'


import Footer from '../components/maketApp/site/Footer'
import About from '../components/maketApp/site/About'
import Contact from '../components/maketApp/site/Contact'

const HomePages = () => {
  return (
    <div>
       <Navbar />
       <Hero />
     
       <About />
       <Services />
       <WhyUs />
  
         <Footer />
    </div>
  )
}

export default HomePages
